import type { Idioma, NoDicionario } from '../tipos';
import { comum } from './comum';
import { dominio } from './dominio';
import { layout } from './layout';
import { auth } from './auth';
import { projetos } from './projetos';
import { dashboard } from './dashboard';
import { documentos } from './documentos';
import { estatisticas } from './estatisticas';
import { apreciacoes } from './apreciacoes';
import { apreciacaoEdicao } from './apreciacao-edicao';
import { apreciacaoTabelas } from './apreciacao-tabelas';
import { apreciacaoModais } from './apreciacao-modais';
import { apreciacaoIa } from './apreciacao-ia';
import { maquinas } from './maquinas';
import { aquisicao } from './aquisicao';
import { imagens } from './imagens';
import { templates } from './templates';
import { cronograma } from './cronograma';
import { relatorio } from './relatorio';
import { revisoes } from './revisoes';

/**
 * Um arquivo por área, e o nome da chave aqui é o primeiro segmento de toda
 * chave daquela área (`t('cronograma.titulo')`). Área nova = arquivo novo +
 * uma linha aqui; nada mais no app precisa mudar.
 */
const areas = {
  comum,
  dominio,
  layout,
  auth,
  projetos,
  dashboard,
  documentos,
  estatisticas,
  apreciacoes,
  apreciacaoEdicao,
  apreciacaoTabelas,
  apreciacaoModais,
  apreciacaoIa,
  maquinas,
  aquisicao,
  imagens,
  templates,
  cronograma,
  relatorio,
  revisoes,
};

export const dicionarios: Record<Idioma, NoDicionario> = {
  pt: Object.fromEntries(Object.entries(areas).map(([nome, a]) => [nome, a.pt])),
  en: Object.fromEntries(Object.entries(areas).map(([nome, a]) => [nome, a.en])),
};

export const areasTraduzidas = Object.keys(areas);
